import ReportsBase from './ReportsBase'
import AWSReportsDataStore from './gateway/AWSReportsDataStore'

export class ReportsAWS extends ReportsBase {
  constructor() {
    super(new AWSReportsDataStore())
  }

  static instance = undefined
  static getInstance() {
    if (ReportsAWS.instance) {
      return ReportsAWS.instance;
    }
    return ReportsAWS.instance = new ReportsAWS()
  }
}

export default ReportsAWS